import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Result, UseCase } from '@digibricks/domains';
import { DecimalNumber } from '../../../domain';
export var GRADING_SUBMISSION_USE_CASE = 'GRADING_SUBMISSION_USE_CASE';
export var GradingSubmissionUseCase = /*#__PURE__*/function (_UseCase) {
  _inherits(GradingSubmissionUseCase, _UseCase);

  var _super = _createSuper(GradingSubmissionUseCase);

  function GradingSubmissionUseCase(submissionRepository) {
    var _this;

    _classCallCheck(this, GradingSubmissionUseCase);

    _this = _super.call(this);
    _this.submissionRepository = submissionRepository;
    return _this;
  }

  _createClass(GradingSubmissionUseCase, [{
    key: "buildUseCase",
    value: function () {
      var _buildUseCase = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(useCaseInput) {
        var submissionId, attendee, submissionSummaryOrError, submissionSummary, result;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                submissionId = useCaseInput.submissionId, attendee = useCaseInput.attendee;
                _context.next = 3;
                return this.submissionRepository.grading(submissionId);

              case 3:
                submissionSummaryOrError = _context.sent;

                if (!submissionSummaryOrError.isFailure) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt("return", Result.fail(submissionSummaryOrError.error));

              case 6:
                submissionSummary = submissionSummaryOrError.getValue();
                result = submissionSummary.result;
                attendee.updateReport({
                  gradedPercentage: DecimalNumber.roundToInteger(result.gradedPercentage.value)
                });
                return _context.abrupt("return", Result.ok({
                  submission: submissionSummary,
                  attendee: attendee
                }));

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function buildUseCase(_x) {
        return _buildUseCase.apply(this, arguments);
      }

      return buildUseCase;
    }()
  }]);

  return GradingSubmissionUseCase;
}(UseCase);